function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBarcodeRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 24H2v6h6v-2H4v-4zM2 8h2V4h4V2H2v6zM28 28h-4v2h6v-6h-2v4zM24 2v2h4v4h2V2h-6zM10 23h4V9h-4v14zM16 23h2V9h-2v14zM20 23h2V9h-2v14z",
    fill: props.color
  }));
}

export default SvgIconBarcodeRexOutline;